/** Reviewitems voor de marketingpagina (avatarUrl = externe foto-URL). */
export type ReviewItem = {
  id: string;
  quote: string;
  name: string;
  role: string;
  initials: string;
  avatarUrl: string;
};

export const REVIEW_HIGHLIGHTS = [
  {
    title: 'Van inschatting naar gesprek',
    text: 'Bewoners én installateurs gebruiken ComfortTool™ om het eerste gesprek scherper te zetten — minder giswerk, meer structuur.',
  },
  {
    title: 'Transparant per ruimte',
    text: 'Per kamer of zone zie je waar het zwaar wordt voor verwarming of koeling, zodat je niet alleen naar “het totaal” kijkt.',
  },
  {
    title: 'Hulp erbij',
    text: 'Help, Troubleshooting en de installatieadviseur (indien actief) horen bij je scan — en voor maatwerk: contact met een mens.',
  },
] as const;

export const REVIEWS: ReviewItem[] = [
  {
    id: '1',
    quote:
      'We gebruiken de scan in de intake: klant vult vooraf in, wij starten het gesprek met cijfers op tafel. Scheelt een ronde giswerk.',
    name: 'M. de Vries',
    role: 'Installatiebedrijf (Midden-NL)',
    initials: 'MV',
    avatarUrl: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=128&h=128&fit=crop&crop=faces',
  },
  {
    id: '2',
    quote:
      'Als VvE-beheerder wilde ik snel zicht op koellast in de bovenste appartementen. Geen excel-hobby nodig — wel een onderbouwde eerste verkenning.',
    name: 'S. El Yazidi',
    role: 'VvE / vastgoedbeheer',
    initials: 'SE',
    avatarUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=128&h=128&fit=crop&crop=faces',
  },
  {
    id: '3',
    quote:
      'Plus-rapport is leesbaar voor de opdrachtgever. Wij blijven de technische check doen, maar de narrative helpt bij draagvlak.',
    name: 'J. Bakker',
    role: 'Technisch adviseur',
    initials: 'JB',
    avatarUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=128&h=128&fit=crop&crop=faces',
  },
  {
    id: '4',
    quote:
      'Ik wilde weten of een warmtepomp überhaupt in de buurt komt van wat ik nodig heb. De scan gaf rust om verder te vergelijken.',
    name: 'L. Janssen',
    role: 'Particuliere gebruiker',
    initials: 'LJ',
    avatarUrl: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=128&h=128&fit=crop&crop=faces',
  },
];
